import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=702d7e6c&"
import script from "./newPage.vue?vue&type=script&lang=js&"
export * from "./newPage.vue?vue&type=script&lang=js&"
import style0 from "./newPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports